import { render, staticRenderFns } from "./corporateGiftDistribution.vue?vue&type=template&id=e6f6f03c&scoped=true&"
import script from "./corporateGiftDistribution.vue?vue&type=script&lang=js&"
export * from "./corporateGiftDistribution.vue?vue&type=script&lang=js&"
import style0 from "./corporateGiftDistribution.vue?vue&type=style&index=0&id=e6f6f03c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f6f03c",
  null
  
)

export default component.exports